import { OrdAllocateI } from '../../api/ord-allocate/ord-allocate.result.int';
import { OrdAllocateQueryI } from '../../api/ord-allocate/ord-allocate.query.int';
import { createActionGroup } from '@ngrx/store';
import { spxCreateApiActions } from '@softpak/components/spx-redux';

export const OrdAllocateActions = createActionGroup({
  source: 'OrdAllocate',
  events: {
    ...spxCreateApiActions<OrdAllocateQueryI, OrdAllocateI>(),
  },
});